export default "__VITE_ASSET__Y0lRKNaT__"